import { lazy } from 'react';
import { authRoles } from 'app/auth';
import config from '../../../config.json';

const Patients = lazy(() => import('./pages/PatientsPage'));
const Subscriptions = lazy(() => import('./pages/SubscriptionsPage'));
const CreateSubscription = lazy(() => import('./pages/CreateSubscription'));
const PatientsMcKesson = lazy(() => import('./McKesson/components/PatientsPage'));
const InvitePatients = lazy(() => import('./pages/InvitePatients'));

const tabs = [
  {
    value: '/patients',
    label: 'Patients',
  },
  {
    value: '/patients/delivery-subscriptions',
    label: 'Subscriptions',
  },
];

const PatientsPage =
  config.deploymentRegion === 'canada' ? <PatientsMcKesson /> : <Patients tabs={tabs} />;

const PatientsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'patients',
      element: PatientsPage,
    },
    {
      path: 'patients/delivery-subscriptions',
      element: <Subscriptions tabs={tabs} />,
    },
    {
      path: 'patients/delivery-subscriptions/new',
      element: <CreateSubscription />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'patients/invite-patients',
      element: <InvitePatients />,
    },
  ],
};

export default PatientsConfig;
